import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '@/contexts/AuthContext'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import Home from '@/pages/Home'
import Login from '@/pages/Login'
import SignUp from '@/pages/SignUp'
import JoinNation from '@/pages/JoinNation'
import WorldList from '@/pages/WorldList'
import WorldCreate from '@/pages/WorldCreate'
import WorldDetail from '@/pages/WorldDetail'
import NationCreate from '@/pages/NationCreate'
import NationDetail from '@/pages/NationDetail'
import NationOverview from '@/pages/NationOverview'
import VoterDemographics from '@/pages/VoterDemographics'
import RegionCreate from '@/pages/RegionCreate'
import RegionDetail from '@/pages/RegionDetail'
import DistrictCreate from '@/pages/DistrictCreate'
import DistrictDetail from '@/pages/DistrictDetail'
import PartyCreate from '@/pages/PartyCreate'
import PartyPage from '@/pages/PartyPage'
import PartyDistrictsPage from '@/pages/PartyDistrictsPage'
import ElectionResultsPage from '@/pages/ElectionResultsPage'
import AdminTestsPage from '@/pages/AdminTestsPage'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<SignUp />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/join"
                element={
                  <ProtectedRoute>
                    <JoinNation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/worlds"
                element={
                  <ProtectedRoute>
                    <WorldList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/worlds/new"
                element={
                  <ProtectedRoute>
                    <WorldCreate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/worlds/:id"
                element={
                  <ProtectedRoute>
                    <WorldDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/worlds/:worldId/nations/new"
                element={
                  <ProtectedRoute>
                    <NationCreate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/nations/:id"
                element={
                  <ProtectedRoute>
                    <NationDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/nations/:id/overview"
                element={
                  <ProtectedRoute>
                    <NationOverview />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/nations/:id/demographics"
                element={
                  <ProtectedRoute>
                    <VoterDemographics />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/nations/:nationId/elections/:electionId"
                element={
                  <ProtectedRoute>
                    <ElectionResultsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/nations/:nationId/parties/new"
                element={
                  <ProtectedRoute>
                    <PartyCreate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/parties/:id"
                element={
                  <ProtectedRoute>
                    <PartyPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/parties/:id/districts"
                element={
                  <ProtectedRoute>
                    <PartyDistrictsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/nations/:nationId/regions/new"
                element={
                  <ProtectedRoute>
                    <RegionCreate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/regions/:id"
                element={
                  <ProtectedRoute>
                    <RegionDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/regions/:regionId/districts/new"
                element={
                  <ProtectedRoute>
                    <DistrictCreate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/districts/:id"
                element={
                  <ProtectedRoute>
                    <DistrictDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/tests"
                element={
                  <ProtectedRoute>
                    <AdminTestsPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}

export default App
